import React from 'react';
import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Card from './card/card';
import styles from './index.less';

const cx = classNames.bind(styles);
const defaultProps = {
  slotsData: [],
  fieldsInfo: [],
};
const propTypes = {
  slotsData: PropTypes.array,
  fieldsInfo: PropTypes.array,
};

class ReportList extends React.Component {
  renderCards = slots => {
    const parseSlots = _.cloneDeep(slots);
    const { refreshSlot, fieldsInfo, activeDashboard } = this.props;
    // sort the data by position Y and render each data.
    return parseSlots.sort((first, next) => (first.slot_position.y - next.slot_position.y)).map(slot => (
      <Card
        slotDetail={slot}
        key={slot.id}
        refreshSlot={refreshSlot}
        fieldsInfo={fieldsInfo}
        activeDashboard={activeDashboard}
      />
    ));
  };

  render() {
    const { slotsData } = this.props;

    return (
      <Row gutter={16} className={cx('report-list-container')}>
        <Col span={12}>
          { this.renderCards(slotsData.filter(data => _.isObject(data.slot_position) && Number(data.slot_position.x) === 0)) }
        </Col>
        <Col span={12}>
          { this.renderCards(slotsData.filter(data => _.isObject(data.slot_position) && Number(data.slot_position.x) === 1)) }
        </Col>
      </Row>
    );
  }
}

ReportList.defaultProps = defaultProps;
ReportList.propTypes = propTypes;

export default ReportList;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/rightSection/reportList.jsx